var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 168,
    viewBox: "0 0 256 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 204,
    height: 132,
    rx: 10,
    fill: "white",
    stroke: "#7A00DA",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 20L128 148",
    stroke: "#E9DAD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 50,
    height: 4,
    rx: 2,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 36,
    width: 56,
    height: 4,
    rx: 2,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 44,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 52,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 62,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 68,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 73,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 79,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 91,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 97,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 90,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 96,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 102,
    width: 48,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 70,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 76,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 82,
    width: 48,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 111,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 117,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 124,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 130,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 108,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 114,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 48,
    height: 2,
    rx: 1,
    fill: "#FF8833",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.95f80287754c446eb6e173dd08c30625.svg";
export { ForwardRef as ReactComponent };